import { createContext } from "react";
import { AwsRum } from "aws-rum-web";

export const RUMContext = createContext<AwsRum | undefined>(undefined);
